const project_domain_prefixes = {
  ru: ["ru", "ruwf"],
  eu: ["pc", "wf"],
};

const checkTerritory = function(territory, host_array) {
  const territory_prefixies = project_domain_prefixes[territory];

  return host_array.some(value => territory_prefixies.includes(value));
};

export default checkTerritory;
